module.exports = __webpack_public_path__ + "static/assets/0f98e06e39d9ea466d7dbeecee38677f.gif";